module.exports = __webpack_public_path__ + "img/packages/labels-preview-tablet.dc1698.jpg";